import React from 'react';

export default function AccessibilityStatement() {
  const updated = "יולי 2026";

  return (
    <main dir="rtl" className="container mx-auto px-4 py-10 text-slate-800">
      <a href="#content" className="sr-only focus:not-sr-only focus:block mb-4 underline">
        דלג לתוכן העיקרי
      </a>

      <header className="mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold">הצהרת נגישות</h1>
        <p className="mt-2 text-sm text-slate-500">עודכן לאחרונה: {updated}</p>
      </header>

      <section id="content" className="prose prose-slate max-w-none rtl:prose-p:leading-8">
        <p>
          אתר <strong>Printeam</strong> פועל לשפר את נגישות השירות הדיגיטלי לכלל הציבור,
          ובכלל זה אנשים עם מוגבלויות. עבודת הנגישות באתר מתייחסת לעקרונות התקן
          הישראלי <strong>ת״י 5568</strong> ולהנחיות <strong>WCAG 2.1</strong>. הצהרה זו
          מתארת את האמצעים הקיימים ואינה מהווה אישור של בדיקת התאמה מלאה.
        </p>

        <h2>אמצעי נגישות הקיימים באתר</h2>
        <ul>
          <li>מסמך האתר הראשי מוגדר בעברית ובכיוון כתיבה מימין לשמאל.</li>
          <li>העמוד כולל קישור לדילוג ישיר לתוכן העיקרי.</li>
          <li>רכיבי ניווט וכפתורים מרכזיים כוללים תוויות נגישות.</li>
          <li>תפריט הניווט תומך בסגירה באמצעות Esc ובהחזרת המיקוד לכפתור הפתיחה.</li>
          <li>הפריסה מותאמת גם למסכים צרים ולמכשירים ניידים.</li>
          <li>זמין באתר תוסף נגישות המספק אפשרויות תצוגה נוספות.</li>
        </ul>

        <h2>טכנולוגיות תומכות</h2>
        <p>
          האתר מבוסס על HTML, CSS ו-JavaScript ומשתמש במאפיינים סמנטיים וב־ARIA
          ברכיבים שבהם הדבר נדרש. התאימות בפועל עשויה להשתנות בין דפדפנים,
          מערכות הפעלה וטכנולוגיות מסייעות.
        </p>

        <h2>חריגות ותוכן שאינו נגיש במלואו</h2>
        <p>
          ייתכן שתוכן מסוים (קבצים ישנים/מדיה חיצונית/מסמכים שהועלו על ידי צד שלישי) טרם הונגש במלואו.
          אנו פועלים לעדכן ולשפר באופן מתמשך. אם נתקלתם בקושי — נשמח לסייע.
        </p>

        <h2>דרכי פנייה בנושאי נגישות</h2>
        <p>בכל בקשה, שאלה או דיווח על בעיית נגישות, ניתן ליצור קשר עם העסק:</p>
        <ul>
          <li>דוא״ל: <a href="mailto:info@printeam.co.il">info@printeam.co.il</a></li>
          <li>טלפון: <a href="tel:+972503969640">050-396-9640</a></li>
          <li>כתובת למשלוח דואר: האורגים 32, חולון</li>
        </ul>
        <p>
          אנא ציינו תיאור הבעיה, כתובת הדף, סוג הדפדפן/מערכת ההפעלה ואמצעי עזר (במידה וקיים), כדי שנוכל
          לטפל בדיווח.
        </p>

        <h2>התחייבות להמשך שיפור</h2>
        <p>
          אנו ממשיכים לבחון דיווחים על קשיי שימוש ולעדכן רכיבי תוכנה, עיצוב ותוכן
          כאשר מזוהה צורך בתיקון או בשיפור.
        </p>

        <h2>מסמך מדיניות</h2>
        <p>
          הצהרה זו נערכה בהתאם ל<strong>תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות),
          התשע"ג–2013</strong>. מטרתנו לקדם חוויית שימוש שוויונית, מכבדת, עצמאית ונוחה לכלל
          הגולשים.
        </p>
      </section>
    </main>
  );
}
